import { useObservable } from 'react-use-observable';

import { Card, Typography } from 'antd';

import type { ShoppingDelivery } from 'v2/interfaces/shopping';
import type { NewRefundServicePermission } from 'v2/services/new-refund-service';
import newRefundService from 'v2/services/new-refund-service';

import BankSlipInstallment from './bankSlipIntallment';
import { BuyerDetails } from './buyerDetails';
import GetCcbTerm from './CcbTerm/getCcbTerm';
import FiscalDocument from './fiscalDocument';
import InvoiceDetail from './invoiceDetails';
import RefundActions from './refundActions';

const PhysicalProduct = ({ delivery }: { delivery: ShoppingDelivery }) => {
  const [user] = useObservable<NewRefundServicePermission>(
    () => newRefundService.getPermissionToNewRefundServiceByInvoiceId(delivery.invoice_id.toString()),
    []
  );

  const hasPermissionToUseNewRefundService = user && user.success && user.data.producer_can_access;

  return (
    <div className='flex flex-col gap-4'>
      <div className='flex items-start gap-3'>
        <img
          className='size-16 shrink-0 rounded bg-(--uizz-antd-color-fill-tertiary) object-cover'
          src={delivery.product.image}
          alt={delivery.product.title}
        />

        <div>
          <Typography.Text className='block'>{delivery.product.title}</Typography.Text>
          {delivery.order.status && <Typography.Text type='success'>{delivery.order.status}</Typography.Text>}

          {delivery.order.tracker_code && (
            <div className='text-sm'>
              <Typography.Text>Rastreio: </Typography.Text>
              <Typography.Text type='secondary'>{delivery.order.tracker_code}</Typography.Text>
            </div>
          )}
          {delivery.freight_value ? (
            <div className='text-sm'>
              <Typography.Text>Frete pago: </Typography.Text>
              <Typography.Text type='secondary'>
                {delivery.freight_value.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: delivery.currency_code
                })}
              </Typography.Text>
            </div>
          ) : null}
        </div>
      </div>

      <BuyerDetails delivery={delivery} />

      <Card title='Dados do remetente'>
        <div className='flex flex-col gap-1'>
          {delivery.producer.name && (
            <div className='text-sm'>
              <Typography.Text>Nome: </Typography.Text>
              <Typography.Text type='secondary'>{delivery.producer.name}</Typography.Text>
            </div>
          )}
          {delivery.producer.email && (
            <div className='text-sm'>
              <Typography.Text>E-mail: </Typography.Text>
              <Typography.Text type='secondary'>{delivery.producer.email}</Typography.Text>
            </div>
          )}
          {delivery.producer.phone && (
            <div className='text-sm'>
              <Typography.Text>Telefone: </Typography.Text>
              <Typography.Text type='secondary'>{delivery.producer.phone}</Typography.Text>
            </div>
          )}
          {delivery.producer.address && (
            <div className='text-sm'>
              <Typography.Text>Endereço: </Typography.Text>
              <Typography.Text type='secondary'>{delivery.producer.address}</Typography.Text>
            </div>
          )}
        </div>
      </Card>

      {!delivery.bankslip_installments && <InvoiceDetail delivery={delivery} />}

      {!delivery.unlimited_installment && delivery?.bankslip_installments && (
        <BankSlipInstallment delivery={delivery} />
      )}

      {hasPermissionToUseNewRefundService && <RefundActions delivery={delivery} />}

      <FiscalDocument delivery={delivery} />

      <GetCcbTerm delivery={delivery} />
    </div>
  );
};

export default PhysicalProduct;
